import { DateTime } from "luxon";

const getDateString = (
	isoUtcDate: string,
	zone: string = "Pacific/Auckland"
): string => {
	return DateTime.fromISO(isoUtcDate, {
		zone: "utc",
	})
		.setZone(zone)
		.toLocaleString(DateTime.DATETIME_MED);
};

const getDateStringNoZone = (isoUtcDate: string): string => {
	return DateTime.fromISO(isoUtcDate).toLocaleString(DateTime.DATETIME_MED);
};

const getRelativeDateString = (
	isoUtcDate: string,
	zone: string = "Pacific/Auckland"
): string => {
	return (
		DateTime.fromISO(isoUtcDate, {
			zone: "utc",
		})
			.setZone(zone)
			.toRelative(DateTime.DATETIME_MED) ?? ""
	);
};

const getYearPart = (isoDate: string): string => {
	return DateTime.fromISO(isoDate).year.toString();
};
const getMonthPart = (isoDate: string): string => {
	return DateTime.fromISO(isoDate).month.toString();
};
const getDayPart = (isoDate: string): string => {
	return DateTime.fromISO(isoDate).day.toString();
};

const zonelessIsoDate = (date: Date | null) => {
	if (date != null) {
		let processedDateParts = [
			date.getFullYear().toString(),
			(date.getMonth() + 1).toString(),
			date.getDate().toString(),
		];

		if (processedDateParts[1].length == 1) {
			processedDateParts[1] = `0${processedDateParts[1]}`;
		}

		if (processedDateParts[2].length == 1) {
			processedDateParts[2] = `0${processedDateParts[2]}`;
		}

		return `${processedDateParts.join("-")}T00:00`;
	} else {
		return null;
	}
};

const zonelessIsoTimeOnly = (date: Date | null) => {
	if (date != null) {
		let processedDateParts = [`${date.getHours()}`, `${date.getMinutes()}`];

		for (let i = 0; i < processedDateParts.length; i++) {
			if (processedDateParts[i].length == 1) {
				processedDateParts[i] = `0${processedDateParts[i]}`;
			}
		}

		return `1970-01-01T${processedDateParts[0]}:${processedDateParts[1]}`;
	} else {
		return null;
	}
};

const dateFromDateArray = (date: Date | Date[] | null) => {
	if (Array.isArray(date)) {
		if (date.length >= 1) {
			return date[0];
		} else {
			return null;
		}
	} else {
		return date;
	}
};

export {
	getDateString,
	getDateStringNoZone,
	getRelativeDateString,
	getYearPart,
	getMonthPart,
	getDayPart,
	zonelessIsoDate,
	zonelessIsoTimeOnly,
	dateFromDateArray,
};
